import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/client-page.tsx");
